import { html, nothing } from "@umbraco-cms/backoffice/external/lit";
import { interceptLitElement } from "../utils/lit";
import { hookPrototypeFunction } from "../utils/hooks";
import { UMB_DOCUMENT_WORKSPACE_CONTEXT } from "@umbraco-cms/backoffice/document";
import { UMB_AUTH_CONTEXT } from "@umbraco-cms/backoffice/auth";

const filterableContentOverviewsAliases = [
    "clientContentOverviewGlobal",
    "clientContentOverviewLocal",
    "globalTemplateOverview",
    "countryTemplateOverview",
];

// Inject the custom category/documentType filter dropdowns for 'document collections' (content overviews).
// The actual filtering logic is handled via our 'document-collection-filtering' extension itself.
interceptLitElement("umb-document-collection", constructor => {
    // First check if the current node is of a content type for which we want to show the filters
    hookPrototypeFunction(constructor, "firstUpdated", function (next) {
        const element = this as any;

        element.showFilters = false;

        element.consumeContext(UMB_DOCUMENT_WORKSPACE_CONTEXT, async (documentContext: any) => {
            if (!documentContext) {
                return;
            }

            const contentTypeKey = documentContext.getContentTypeUnique() as string | null;
            if (!contentTypeKey) {
                return;
            }

            element.consumeContext(UMB_AUTH_CONTEXT, async (authContext: any) => {
                if (!authContext) {
                    return;
                }

                try {
                    const config = authContext.getOpenApiConfiguration();
                    const token = typeof config.token === "function" ? await config.token() : config.token;

                    const response = await fetch(`${config.base}/umbraco/management/api/v1/document-type/${contentTypeKey}`, {
                        credentials: config.credentials,
                        headers: {
                            "Authorization": `Bearer ${token}`,
                        },
                    });

                    if (!response.ok) {
                        return;
                    }

                    const detail = await response.json();
                    const alias = detail?.alias;

                    if (alias && filterableContentOverviewsAliases.includes(alias)) {
                        element.showFilters = true;
                        element.requestUpdate();
                    }
                } catch {
                    // If we can't resolve the content type, don't show the filters
                }
            });
        });

        return next();
    });

    // Then inject the filter element above the collection, by hooking into the 'render' function
    hookPrototypeFunction(constructor, "render", function (next) {
        const element = this as any;
        const showFilters = element.showFilters === true;

        return html`
            ${showFilters ? html`<strada-collection-filters></strada-collection-filters>` : nothing}

            ${next()}
        `;
    });

    return constructor;
});
